import React, { useEffect, useRef, useState, useContext } from "react";
import { useHistory } from "react-router";
import useStyles from "./SequenceOverview.styles";
import { useSelector } from "react-redux";

//@Components
import NoData from "../../../Pages/InformativeComponents/NoData.component";
import { checkImage } from "../../utils";
import SequencePageFilter from "../SequencePageModals/SequencePageFilter";
import SequencePageTools from "../SequencePageTools/SequencePageTools.component";
import SequenceDefaultTable from "../SequenceTable/SequenceDefaultTable.jsx";
import SequencePageNewSequenceModal from "./../SequencePageModals/SequencePageNewSequenceModal";
//@MUI
import { Modal } from "@material-ui/core";
import { Typography } from "@mui/material";
//@API
import { fget, fpost, fpostBFF } from "../../../API/callsAPI";
import CSVImportModal from "../../Utilities/CSVImportModal/CSVImportModal";
import ErrorOrSuccessMessage from "../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import ExportModal from "../../Utilities/ExportModal/ExportModal";
import Loader from "../../Utilities/Loader/Loader";
import NewDataLoadingLoader from "../../Utilities/NewDataLoadingLoader/NewDataLoadingLoader.component";
import NoFileFoundModal from "../../Utilities/NoFileFoundModal/NoFileFoundModal";
import { MovieColabContext } from "../../../Context/MovieColabContext";
import { selectAppliedFilterForTrackable } from "../../../redux/selectors/projectFilters";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component.jsx";
import SequenceCustomTable from "../SequenceTable/SequenceCustomTable.jsx";
import { mapFieldsFromConfig } from "../../Utilities/CustomTableForAllTrackables/fieldMapper.js";

export default function SequenceOverview(props) {
  const classes = useStyles();
  const history = useHistory();
  const tableRef = useRef();
  const { trackableClass } = useContext(MovieColabContext);
  const sequenceTrackableId = trackableClass?.find(
    (trackable) => trackable.model?.toLowerCase() === "sequence",
  )?.id;
  const appliedFilter = useSelector((state) =>
    selectAppliedFilterForTrackable(state, sequenceTrackableId),
  );
  const appliedFilterIds = appliedFilter?.id != null ? [appliedFilter.id] : [];
  const appliedFilterKey = appliedFilter
    ? `${appliedFilter.id}:${JSON.stringify(appliedFilter.filters ?? [])}`
    : "";

  const [sliderState, setSliderState] = useState("0");
  const [sequenceList, setSequenceList] = React.useState();
  const [sequenceFilteredStatus, setSequenceFilteredStatus] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [isNewSequenceModalOpen, setNewSequenceModalOpen] = useState(false);
  const [isSequenceFilterModal, setSequenceFilterModal] = useState(false);
  const [sortByDefault, setSortByDefault] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [toggler, setToggler] = useState(false);
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [file, setFile] = useState("");
  const [dragScreen, setDragScreen] = useState(false);
  //state will be true when we start drag file inside modals
  const [dragFileEnterModal, setDragFileEnterModal] = useState(false);
  const [scrollValue, setScrollValue] = useState("");
  const [updateOnPageChange, setUpdateOnPageChange] = useState(0);
  const [isNewPageLoading, setIsNewPageLoading] = useState(false);
  const [episodeId, setEpisodeId] = useState("");
  const [selectedEpi, setSelectedEpi] = useState("");
  const [episodeList, setEpisodeList] = useState([]);
  const [sequenceStats, setSequenceStats] = useState({
    total: 0,
    visibleCount: 0,
  });
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [openBulkImportModal, setOpenBulkImportModal] = useState(false);
  const [isExportModalOpen, setIsExportModalOpen] = useState(false);
  const [allFieldsConfig, setAllFieldsConfig] = useState([]);
  const [isToggleView, setIsToggleView] = useState(false);

  const decodedURL = decodeURIComponent(
    escape(window.atob(history.location.search.substring(1))),
  );
  let searchParams = new URLSearchParams(decodedURL);

  useEffect(() => {
    getAllEpisodes();
    setEpisodeId(searchParams.get("episodeId") || "");
    setSequenceFilteredStatus(searchParams.get("status") || "");
    setSortByDefault(searchParams.get("sortBy") || "A-Z");
    if (
      (searchParams.get("status") === null ||
        searchParams.get("status") === "") &&
      !searchParams.get("episodeId")
    ) {
      fetchSequence();
    }
    var scrollStored = JSON.parse(localStorage.getItem("scroll"));
    if (scrollStored) {
      setScrollValue(scrollStored.sequence);
    } else {
      const scrollData = {
        asset: "0",
        assetVersion: "0",
        sequence: "0",
        shots: "0",
        shotVersion: "0",
      };
      localStorage.setItem("scroll", JSON.stringify(scrollData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      props.params.projectId ||
      parseInt(sequenceFilteredStatus) > 0 ||
      updateOnPageChange ||
      refreshCounter ||
      episodeId
    ) {
      fetchFilteredSequence();
    }
    if (episodeList.length > 0 && episodeId) {
      const filteredEpi = episodeList.filter((eachEpi) => {
        if (eachEpi.id == episodeId) return eachEpi;
      });
      if (filteredEpi) {
        setSelectedEpi(filteredEpi[0]);
      }
    } else if (!episodeId) {
      setSelectedEpi("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    appliedFilterKey,
    props.params.projectId,
    sequenceFilteredStatus,
    currentPage,
    updateOnPageChange,
    refreshCounter,
    episodeId,
    episodeList,
  ]);

  const updateRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  const handlePageChange = (pageNo) => {
    setCurrentPage(pageNo);
    setUpdateOnPageChange(updateOnPageChange + 1);
  };

  function handleNewSequenceModalState() {
    setNewSequenceModalOpen(!isNewSequenceModalOpen);
  }

  const handleFilterModal = () => {
    setSequenceFilterModal(!isSequenceFilterModal);
  };

  const handleToggler = () => {
    setToggler(!toggler);
  };

  const getAllEpisodes = async () => {
    try {
      const episodeListRes = await fget({
        url: `trackables/episode/?project=${props.params.projectId}`,
      });
      setEpisodeList(episodeListRes.data.results);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchFilteredSequence = async () => {
    let url = `trackables/shot-sequence/v2/?project=${props.params.projectId}&page=${currentPage}`;
    if (episodeId) {
      url += `&episode=${episodeId}`;
    }
    if (sequenceFilteredStatus) {
      url += `&status=${sequenceFilteredStatus}`;
    }
    if (sortByDefault) {
      url += `&sortBy=${sortByDefault}`;
    }
    appliedFilterIds.forEach((filterId) => {
      url += `&filter=${filterId}`;
    });
    try {
      const res = await fget({ url });
      setSequenceList(res.data);
      setIsLoaded(true);
      setIsNewPageLoading(false);
    } catch (error) {
      console.error("Error loading filtered sequences", error);
      setIsNewPageLoading(false);
    }
    history.push("?" + btoa(unescape(encodeURIComponent(url.split("?")[1]))));
  };

  //post req bff to get projectDetails,status,sequence
  const fetchSequence = async () => {
    const sequence = {
      url: "web/sequence/list/",
      data: {
        project_id: props.params.projectId,
      },
    };
    try {
      const sequenceRes = await fpostBFF(sequence);
      setSequenceStats((prevData) => ({
        ...prevData,
        visibleCount: sequenceRes?.data?.sequence_list.count,
      }));
      setIsLoaded(true);
      setStatusList(sequenceRes?.data?.status_list?.results);
      window.scrollTo(0, sessionStorage.getItem("scrollpos"));
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: `Error on loading sequences`,
        isError: true,
      });
      setIsLoaded(true);
    }
  };

  async function fetchFile(id) {
    if (id) {
      // fetching the signed url only if file is there

      try {
        const res = await fget({
          url: `trackables/sequence/${id}/file`,
        });
        setFile(res?.data?.signed_url);
      } catch (error) {
        setFile("");
        console.log(error);
      }
    } else setFile("");
  }

  useEffect(() => {
    if (sequenceList && sequenceList.count !== 0) {
      const fields = mapFieldsFromConfig(
        sequenceList.fields_config,
        sequenceList.custom_fields,
        sequenceList.default_fields,
      );
      setAllFieldsConfig(fields);
    }
    sequenceList?.results &&
      searchParams.get("sortBy") &&
      handleSubmitSort(searchParams.get("sortBy"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sequenceList]);

  //Function to sort Sequences
  function handleSubmitSort(sortBy) {
    searchParams.set("sortBy", `${sortBy}`);
    history.push(
      "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
    );

    switch (sortBy) {
      case "A-Z":
        sequenceList?.results?.sort((a, b) => a.code.localeCompare(b.code));
        setSortByDefault("A-Z");
        break;
      case "Z-A":
        sequenceList?.results?.sort((a, b) => b.code.localeCompare(a.code));
        setSortByDefault("Z-A");
        break;
      case "LatestModified":
        sequenceList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateB - dateA;
        });
        setSortByDefault("LatestModified");
        break;
      case "LastModified":
        sequenceList?.results?.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateA - dateB;
        });
        setSortByDefault("LastModified");
        break;
      case "DateCreated":
        sequenceList?.results?.sort(function (a, b) {
          var dateA = new Date(a.created_at),
            dateB = new Date(b.created_at);
          return dateA - dateB;
        });
        setSortByDefault("DateCreated");
        break;
      default:
        return sequenceList?.results;
    }
  }
  //event to save scrollBar position
  window.onbeforeunload = function (e) {
    sessionStorage.setItem("scrollpos", window.scrollY);
  };

  const handleDragFile = (e) => {
    setDragScreen(true);
    if (e.type === "drop") {
      //if we drop file , removing drag zone screen
      setDragScreen(false);
    }
    if (e.type === "dragleave") {
      //if we leave the drag file , removing drag zone screen
      if (dragFileEnterModal) {
        setDragScreen(true);
      } else {
        setDragScreen(false);
      }
    }
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragScreen = (el) => {
    setDragScreen(el);
  };

  let scrollTimer = null;
  const handleTableScroll = (e) => {
    if (scrollTimer !== null) clearTimeout(scrollTimer);

    scrollTimer = setTimeout(() => {
      searchParams.set("scroll", `${e.target.scrollTop}`);
      history.push(
        "?" + btoa(unescape(encodeURIComponent(searchParams.toString()))),
      );
      let scrollStored = JSON.parse(localStorage.getItem("scroll"));
      scrollStored.sequence = e.target.scrollTop;
      localStorage.setItem("scroll", JSON.stringify(scrollStored));
    }, 700);
  };

  const getSequenceStats = async () => {
    try {
      const sequenceRes = await fget({
        url: `trackables/trackable-count/sequence/${props.params.projectId}/`,
      });
      setSequenceStats((prevData) => ({
        ...prevData,
        total: sequenceRes?.data?.instances,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getSequenceStats();
  }, [refreshCounter]);

  const fetchAllSequenceData = async () => {
    const PAGE_SIZE = 50;
    const firstRes = await fget({
      url: `trackables/shot-sequence/?page=1&project=${props.params.projectId}&status=${sequenceFilteredStatus}`,
    });
    const totalCount = firstRes.data.count;
    const totalPages = Math.ceil(totalCount / PAGE_SIZE);

    if (totalPages <= 1) {
      return firstRes.data.results;
    }

    const remainingPromises = Array.from({ length: totalPages - 1 }, (_, i) =>
      fget({
        url: `trackables/shot-sequence/?page=${i + 2}&project=${props.params.projectId}&status=${sequenceFilteredStatus}`,
      }),
    );
    const remainingResults = await Promise.all(remainingPromises);

    return [
      ...firstRes.data.results,
      ...remainingResults.flatMap((res) => res.data.results),
    ];
  };

  const createSequenceInBulk = async (
    tableData,
    columnMappings,
    trackableType,
    defaultFields = [],
  ) => {
    const validApiFields = new Set(defaultFields.map((f) => f.name));
    const sequences = tableData.map((row) =>
      Object.fromEntries(
        Object.entries(columnMappings)
          .filter(
            ([, apiField]) =>
              apiField && apiField !== "none" && validApiFields.has(apiField),
          )
          .map(([csvHeader, apiField]) => [apiField, row[csvHeader]]),
      ),
    );
    sequences.forEach((sequence) => {
      sequence.project = props.params.projectId;
      sequence.file_path = "";
    });
    try {
      const res = await fpost({
        url: `trackables/shot-sequence/`,
        data: sequences,
      });
      if (res.status === 200 || 201) {
        setSnackValue({
          isOpen: true,
          message: "Sequences imported successfully",
          isError: false,
        });
        updateRefreshCounter();
        return true;
      } else {
        setSnackValue({
          isOpen: true,
          message: "Error importing sequences",
          isError: true,
        });
        return false;
      }
    } catch (error) {
      console.log(error);
      setSnackValue({
        isOpen: true,
        message: error.response.data.detail || "Error importing sequences",
        isError: true,
      });
      return false;
    }
  };

  if (props.embedded) {
    return (
      <>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "bold",
            color: "#606479",
            "&:hover": { color: "white" },
          }}
        >
          Sequence
        </Typography>
        {!isLoaded && <Loader />}
        {isLoaded && sequenceList && sequenceList.count === 0 && <NoData />}
        {isLoaded && sequenceList && sequenceList.count > 0 && (
          <>
            <SequenceDefaultTable
              sequenceList={sequenceList}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
              projectId={props.params.projectId}
              statusList={statusList}
              sliderState={sliderState}
              toggler={toggler}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              handleTableScroll={handleTableScroll}
              tableRef={tableRef}
              scrollValue={scrollValue}
              currentPage={currentPage}
              setIsNewPageLoading={setIsNewPageLoading}
              handlePageChange={handlePageChange}
              setViewMode={props.setViewMode}
            />
            {sequenceList.count > 50 && (
              <footer style={{ bottom: "0", height: "100%" }}>
                <div>
                  <CustomPagination
                    handlePageChange={handlePageChange}
                    currentPage={currentPage}
                    totalItem={sequenceList.count}
                    totalPage={Math.ceil(sequenceList.count / 50)}
                    setIsNewPageLoading={setIsNewPageLoading}
                  />
                </div>
              </footer>
            )}
          </>
        )}
      </>
    );
  }

  return (
    <div
      className={classes.root}
      onDragEnter={(e) => handleDragFile(e)}
      onDrop={(e) => handleDragFile(e)}
      onDragLeave={(e) => handleDragFile(e)}
      onDragOver={(e) => handleDragFile(e)}
    >
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <SequencePageTools
        handleSliderChange={(value) => {
          setSliderState(value);
          sessionStorage.setItem("sliderState", `${sliderState}`);
        }}
        sliderState={sliderState}
        openNewSequenceModal={handleNewSequenceModalState}
        status={statusList}
        filterValues={{ status: sequenceFilteredStatus }}
        handleToggler={handleToggler}
        onSubmit={handleSubmitSort}
        defaultvalue={sortByDefault}
        sequenceStats={sequenceStats}
        handleFilterModal={handleFilterModal}
        episodeId={episodeId}
        selectedEpi={selectedEpi}
        openImportModal={() => setOpenBulkImportModal(true)}
        handleOpenExportModal={() => setIsExportModalOpen(true)}
        projectId={props.params.projectId}
        isToggleView={isToggleView}
        handleToggleView={() => setIsToggleView(!isToggleView)}
      />
      {!isLoaded && <Loader />}
      {isLoaded && sequenceList && sequenceList.count === 0 && <NoData />}
      {isLoaded && sequenceList && sequenceList.count > 0 && (
        <>
          {isToggleView ? (
            <SequenceCustomTable
              sequenceList={sequenceList}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
              projectId={props.params.projectId}
              statusList={statusList}
              sliderState={sliderState}
              toggler={toggler}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              handleTableScroll={handleTableScroll}
              tableRef={tableRef}
              scrollValue={scrollValue}
              currentPage={currentPage}
              setIsNewPageLoading={setIsNewPageLoading}
              handlePageChange={handlePageChange}
              allFieldsConfig={allFieldsConfig}
            />
          ) : (
            <SequenceDefaultTable
              sequenceList={sequenceList}
              dragScreen={dragScreen}
              handleDragScreen={handleDragScreen}
              setDragFileEnterModal={setDragFileEnterModal}
              projectId={props.params.projectId}
              statusList={statusList}
              sliderState={sliderState}
              toggler={toggler}
              updateRefreshCounter={updateRefreshCounter}
              setIsViewModalOpen={setIsViewModalOpen}
              fetchFile={fetchFile}
              handleTableScroll={handleTableScroll}
              tableRef={tableRef}
              scrollValue={scrollValue}
              currentPage={currentPage}
              setIsNewPageLoading={setIsNewPageLoading}
              handlePageChange={handlePageChange}
              customFields={sequenceList.custom_fields}
            />
          )}
          {sequenceList.count > 50 && (
            <footer style={{ bottom: "0", height: "100%" }}>
              <div>
                <CustomPagination
                  handlePageChange={handlePageChange}
                  currentPage={currentPage}
                  totalItem={sequenceList.count}
                  totalPage={Math.ceil(sequenceList.count / 50)}
                  setIsNewPageLoading={setIsNewPageLoading}
                />
              </div>
            </footer>
          )}
        </>
      )}
      <Modal className={classes.sequencePageModals} open={isNewPageLoading}>
        <NewDataLoadingLoader trackable="Sequences" />
      </Modal>
      <Modal
        className={classes.sequencePageModals}
        open={isNewSequenceModalOpen}
        onClose={() => setNewSequenceModalOpen(false)}
      >
        <SequencePageNewSequenceModal
          dragScreen={dragScreen}
          handleDragScreen={handleDragScreen}
          setDragFileEnterModal={setDragFileEnterModal}
          projectId={props.params.projectId}
          status={statusList}
          handleNewSequenceModal={handleNewSequenceModalState}
          updateRefreshCounter={updateRefreshCounter}
          customFields={sequenceList?.custom_fields}
        />
      </Modal>
      <Modal
        className={classes.sequencePageModals}
        open={isViewModalOpen}
        onClose={() => {
          setIsViewModalOpen(false);
        }}
      >
        {file ? (
          checkImage(file) ? (
            <img
              src={file}
              className="card-img-top"
              alt="sequence"
              style={{ width: "500px", height: "auto" }}
            />
          ) : (
            <video
              src={file}
              controls
              autoPlay
              style={{ width: "auto", height: "500px" }}
            />
          )
        ) : (
          <NoFileFoundModal
            handleClose={() => {
              setIsViewModalOpen(false);
            }}
          />
        )}
      </Modal>
      <Modal
        className={classes.sequencePageModals}
        open={isSequenceFilterModal}
        onClose={handleFilterModal}
      >
        <SequencePageFilter
          episodeList={episodeList}
          handleFilterModal={handleFilterModal}
          episodeId={episodeId}
          handleEpisodeChange={(value) => {
            setEpisodeId(value);
            value === "" && updateRefreshCounter();
          }}
        />
      </Modal>
      <Modal
        className={classes.sequencePageModals}
        open={openBulkImportModal}
        onClose={() => setOpenBulkImportModal(false)}
      >
        <CSVImportModal
          createInBulk={createSequenceInBulk}
          trackableType="sequence"
          closeModal={() => setOpenBulkImportModal(false)}
          projectId={props.params.projectId}
          requiredFields={["Code(name)"]}
        />
      </Modal>
      <Modal
        className={classes.assetsPageModals}
        open={isExportModalOpen}
        onClose={() => {
          setIsExportModalOpen(false);
        }}
      >
        <ExportModal
          headersList={[
            "Sequence Name",
            "Last Modified",
            "Description",
            "Status",
            "Episode",
          ]}
          valuesList={[
            { name: "code", type: "string" },
            { name: "updated_at", type: "date" },
            { name: "description", type: "string" },
            { name: "status", type: "object", key: "name" },
            { name: "parent_episode", type: "object", key: "name" },
          ]}
          fetchAllData={fetchAllSequenceData}
          handleClose={() => setIsExportModalOpen(false)}
        />
      </Modal>
    </div>
  );
}
